import { useState } from "react";
import { trackFeed } from "@/mocks/stories";

const tagPill: Record<string, string> = {
  反转: "bg-accent-500/90 text-foreground-950",
  声明: "bg-background-200 text-foreground-800",
  实锤: "bg-primary-500 text-background-50",
  爆料: "bg-background-200 text-foreground-800",
  首发: "bg-background-200 text-foreground-800",
};

const onlyTypes = ["声明", "反转"];

export default function TrackTimeline() {
  const [only, setOnly] = useState(false);
  const nodes = only ? trackFeed.filter((n) => onlyTypes.includes(n.tag)) : trackFeed;
  const last = trackFeed[0];

  return (
    <section id="track" className="scroll-mt-24 bg-foreground-950 text-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-10 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <p className="flex items-center gap-2 text-[11px] font-bold tracking-[0.2em] text-accent-400">
                <span className="h-3 w-3 bg-accent-500" />
                发酵追踪 · LIVE TRACK
              </p>
              <h2 className="font-heading mt-3 text-2xl font-black leading-tight text-background-50 md:text-[34px] md:leading-[1.2]">
                录音门 · 9 分钟音频的
                <br />
                48 小时
              </h2>
              <p className="mt-3 text-sm leading-6 text-background-100/70">
                一条事件从首发到反转的全过程留痕。时间戳只进不退，任何口径变化都标注来源与证据状态。
              </p>

              <div className="mt-6 grid grid-cols-3 gap-2.5">
                {[
                  { l: "当前口径", v: "3 版" },
                  { l: "首发至今", v: "48h" },
                  { l: "观点跟帖", v: "2.4万" },
                ].map((m) => (
                  <div key={m.l} className="rounded-md border border-foreground-800 bg-foreground-900 p-3">
                    <p className="text-[11px] text-background-100/50">{m.l}</p>
                    <p className="mt-1 text-lg font-black text-background-50">{m.v}</p>
                  </div>
                ))}
              </div>

              <div className="mt-5 rounded-md border border-foreground-800 bg-foreground-900 p-4">
                <p className="text-xs text-background-100/60">最近一次变动</p>
                <p className="mt-1.5 text-sm font-semibold text-background-50">{last.title}</p>
                <p className="mt-1 text-[11px] text-accent-400">· {last.time} · 标记为「{last.tag}」</p>
              </div>

              <div className="mt-6 flex flex-wrap gap-2">
                <button
                  type="button"
                  onClick={() => setOnly(false)}
                  className={`rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${
                    !only ? "bg-primary-500 text-background-50" : "border border-foreground-800 text-background-100/70"
                  }`}
                >
                  全部节点
                </button>
                <button
                  type="button"
                  onClick={() => setOnly(true)}
                  className={`rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${
                    only ? "bg-accent-500 text-foreground-950" : "border border-foreground-800 text-background-100/70"
                  }`}
                >
                  只看口径变化
                </button>
              </div>

              <p className="mt-5 flex items-start gap-2 text-[11px] leading-5 text-background-100/45">
                <i className="ri-shield-check-line mt-0.5 shrink-0" />
                演示站点 · 时间线与口径为虚构内容，仅用于呈现「发酵追踪」信息架构。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="mb-5 flex items-center justify-between border-b border-foreground-800 pb-3">
              <span className="text-xs font-bold tracking-widest text-background-100/60">关键节点 · 倒序</span>
              <span className="inline-flex items-center gap-1.5 text-xs text-background-100/50">
                <i className="ri-time-line" />最近更新 {last.time}
              </span>
            </div>

            {nodes.map((n, i) => (
              <div key={n.time + n.title} className="flex gap-4">
                <div className="flex w-6 shrink-0 flex-col items-center">
                  <span
                    className={`mt-1 h-3.5 w-3.5 rounded-full border-2 ${
                      n.hot ? "border-primary-400" : "border-accent-400"
                    }`}
                  />
                  {i !== nodes.length - 1 && <span className="mt-1 w-px flex-1 bg-foreground-800/60" />}
                </div>
                <div className="min-w-0 flex-1 pb-8">
                  <div className="mb-2 flex flex-wrap items-center gap-2 text-xs">
                    <span
                      className={`inline-flex items-center gap-1 whitespace-nowrap rounded px-2 py-0.5 font-bold ${
                        tagPill[n.tag] ?? "bg-background-200 text-foreground-800"
                      }`}
                    >
                      {n.hot && <i className="ri-fire-fill" />}
                      {n.tag}
                    </span>
                    <span className="text-background-100/45">{n.time}</span>
                  </div>
                  <div className="rounded-lg border border-foreground-800 bg-foreground-900/70 p-4">
                    <h4 className="text-[15px] font-bold text-background-50 md:text-base">{n.title}</h4>
                    <p className="mt-1.5 text-sm leading-6 text-background-100/70">{n.body}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}